import { render, staticRenderFns } from "./LTransferDestinations.vue?vue&type=template&id=45231243&"
import script from "./LTransferDestinations.vue?vue&type=script&lang=ts&"
export * from "./LTransferDestinations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports